import { createFetchEntityAction } from '../generic/entityAction';

export const GROUP_AGE_LIST = 'GROUP_AGE_LIST';

export default {
    fetchAll: createFetchEntityAction(locationId => `/api/locations/${locationId}/group-ages`, GROUP_AGE_LIST),
};